<mat-form-field appearance="outline" [class.full-width]="full_width()">
  <mat-label>Empresa</mat-label>
  <input
    matInput
    type="text"
    [formControl]="company_search"
    [matAutocomplete]="companyAutocomplete"
    [placeholder]="have_placeholder() ? 'Buscar por empresa o proyecto' : ''"
  />
  <mat-autocomplete
    #companyAutocomplete="matAutocomplete"
    [class]="autocomplete_panel_class()"
    [displayWith]="displayCompany.bind(this)"
    (optionSelected)="onCompanySelected($event)"
  >
    @if (company_search_term().length > 0 && company_search_term().length < 3) {
      <mat-option disabled>Escribe al menos 3 caracteres para buscar.</mat-option>
    } @else if (company_search_loading()) {
      <mat-option disabled>
        <mat-spinner diameter="24"></mat-spinner>
      </mat-option>
    } @else if (company_search_term().length >= 3 && filtered_companies.length === 0) {
      <mat-option disabled>No se han encontrado coincidencias.</mat-option>
    } @else {
      @for (company of filtered_companies; track company.id) {
        <mat-option [value]="company">
          <span [class]="optionClass('')">
            @if (company.has_company_logo) {
              <img [class]="optionClass('logo')" [src]="company.logo_url!" [alt]="company.label" (error)="onCompanyLogoError(company.id)" />
            } @else {
              <span class="material-icons" [class]="optionClass('icon')" aria-hidden="true">business</span>
            }
            <span [class]="optionClass('text')">
              <span [class]="optionClass('label')">{{ company.label }}</span>
              @if (company.subtitle) {
                <span [class]="optionClass('subtitle')">{{ company.subtitle }}</span>
              }
            </span>
          </span>
        </mat-option>
      }
    }
  </mat-autocomplete>
  @if (have_mat_icon()) {
    <mat-icon matSuffix>business</mat-icon>
  }
</mat-form-field>
